module.exports = __webpack_public_path__ + "static/media/intro.2599d3f1.mp3";